import "starknet";
import "./connector-c50f5de7.js";
import { I as m } from "./index-ae0f52d0.js";
export {
  m as InjectedConnector
};
